import React, { FunctionComponent, useEffect } from 'react'
import { Col, Container, Row } from 'react-grid-system'
import { useLocation } from 'react-router-dom'

import { ClinAnnounceBar } from '../../components/ClinAnnounceBar'
import { ClinSpacer } from '../../components/ClinSpacer'
import { useAppContext } from '../../context/app'
import {
  clearAnnounceEvent,
  updateAnnounceClearFlag
} from '../../events/AnnounceEvent'

export const AnnounceContainer: FunctionComponent = () => {
  const { dispatch, announcement } = useAppContext()
  const location = useLocation()

  // Clean up announce once nav changes
  useEffect(() => {
    if (announcement?.clearOnNavigationFlag) {
      dispatch(clearAnnounceEvent())
    }
    dispatch(updateAnnounceClearFlag(true))
  }, [location.pathname, dispatch])

  return announcement ? (
    <Container>
      <Row>
        <Col>
          <ClinSpacer />
          <ClinAnnounceBar
            mode={announcement.mode}
            title={announcement.title}
            isDismissible={true}
            handleClose={() => dispatch(clearAnnounceEvent())}
          >
            {announcement.description}
          </ClinAnnounceBar>
        </Col>
      </Row>
    </Container>
  ) : null
}
